import awardGif from '@/assets/award.gif'

export const AWARD_TOUR_CONFIG = [
  {
    target: '#awardee',
    title: 'Give awards to 1 or many',
    content: 'You can give an award to one or more team members at once. ',
    placement: 'bottom-start'
  },
  {
    target: '#pick-badge',
    title: 'Pick a Badge',
    content:
      'Choose the right badge for your awards from our templates or create your own custom badge',
    placement: 'left'
  },
  {
    target: '#share-award',
    title: 'Let everyone know',
    content:
      'Choose how you want to share this award, with the team or with the entire organization',
    placement: 'top'
  }
]

export const KR_AWARD_ICON_TOUR_CONFIG = [
  {
    target: '#kr-award-tour-1',
    classes: 'z-index-auto',
    title: 'Celebrate wins with Awards 🥇 ',
    content: `Watch a quick video on Awards in North <br /><br /> <img alt="Award GIF" width="100%" src=${awardGif} />`,
    placement: 'bottom',
    size: 'md'
  }
]
